import { render, staticRenderFns } from "./MappingPropertyInput.vue?vue&type=template&id=71b2ff14"
import script from "./MappingPropertyInput.vue?vue&type=script&lang=ts"
export * from "./MappingPropertyInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports